import { Injectable, inject, DOCUMENT } from '@angular/core';

interface Scripts {
    name: string;
    src: string;
}
export const ScriptStore: Scripts[] = [
    { name: 'freshwidget', src: 'https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.js' },
];

@Injectable({
    providedIn: 'root',
})
export class ExternalScriptService {
    readonly #document = inject(DOCUMENT);

    private scripts: Record<string, { loaded: boolean; src: string }> = {};

    constructor() {
        ScriptStore.forEach(script => {
            this.scripts[script.name] = {
                loaded: false,
                src: script.src,
            };
        });
    }

    load(name: string) {
        return new Promise((resolve, _reject) => {
            if (this.scripts[name].loaded) {
                resolve({ script: name, loaded: true, status: 'Already Loaded' });
            } else {
                const script = this.#document.createElement('script');
                script.type = 'text/javascript';
                script.src = this.scripts[name].src;
                script.onload = () => {
                    this.scripts[name].loaded = true;
                    resolve({ script: name, loaded: true, status: 'Loaded' });
                };
                script.onerror = () => resolve({ script: name, loaded: false, status: 'Loaded' });
                this.#document.getElementsByTagName('head')[0].appendChild(script);
            }
        });
    }
}
